import { render, staticRenderFns } from "./ContractorItem.vue?vue&type=template&id=8659dd34&scoped=true&"
import script from "./ContractorItem.vue?vue&type=script&lang=js&"
export * from "./ContractorItem.vue?vue&type=script&lang=js&"
import style0 from "./ContractorItem.vue?vue&type=style&index=0&id=8659dd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8659dd34",
  null
  
)

export default component.exports